module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['bk-header', {
      'is-static': _vm.isStatic || _vm.isFixed
    }]
  }, [_c('img', {
    staticClass: "bk-logo",
    attrs: {
      "src": require("../images/common/logo.png"),
      "width": "188px",
      "height": "32px",
      "alt": "蓝鲸智云|S-mart"
    },
    on: {
      "click": function($event) {
        return _vm.goToDoc(_vm.navList[0])
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "bk-nav"
  }, _vm._l((_vm.navList), function(nav, navIndex) {
    return _c('li', {
      key: navIndex,
      class: ['nav-menu', {
        'active': _vm.curNavTab === nav.name
      }]
    }, [(nav.children) ? [_c('el-popover', {
      attrs: {
        "placement": "bottom",
        "trigger": "hover",
        "popper-class": 'second-nav-pop'
      }
    }, [_c('div', {
      attrs: {
        "slot": "reference"
      },
      on: {
        "click": function($event) {
          return _vm.goToDoc(nav)
        }
      },
      slot: "reference"
    }, [_c('span', {
      class: ['nav-title', {
        'default': !nav.url
      }]
    }, [_vm._v(_vm._s(nav.title))])]), _vm._v(" "), _c('div', {
      staticClass: "child-list"
    }, _vm._l((nav.children), function(child, childIdx) {
      return _c('div', {
        key: childIdx,
        staticClass: "child-item"
      }, [_c('p', {
        staticClass: "second-title"
      }, [_c('span', {
        class: [{
          'is-link': child.url
        }],
        on: {
          "click": function($event) {
            return _vm.goToDoc(child)
          }
        }
      }, [_vm._v(_vm._s(child.title))])]), _vm._v(" "), _c('ul', {
        staticClass: "second-list"
      }, _vm._l((child.list), function(item) {
        return _c('li', {
          key: item.url,
          class: {
            'active': _vm.secondNav === item.name,
            'is-disable': item.disable
          },
          on: {
            "click": function($event) {
              return _vm.goToDoc(item)
            }
          }
        }, [_c('span', [_vm._v(_vm._s(item.title))])])
      }), 0)])
    }), 0)]), _vm._v(" "), _c('img', {
      staticClass: "triangle",
      attrs: {
        "src": require("../images/community/angle-down.png"),
        "alt": ""
      }
    })] : [_c('span', {
      staticClass: "nav-title",
      on: {
        "click": function($event) {
          return _vm.goToDoc(nav)
        }
      }
    }, [_vm._v(_vm._s(nav.title))])]], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "online-experience"
  }, [_c('div', {
    staticClass: "experience",
    on: {
      "click": function($event) {
        return _vm.goToDoc({
          url: '/s-mart/online-env'
        })
      }
    }
  }, [_vm._v("在线体验")])]), _vm._v(" "), (!_vm.isLogin) ? [_c('a', {
    staticClass: "login-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("登录")])] : [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "click",
      "popper-class": "msg-popover"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('span', {
    staticClass: "msg-icon",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('i', {
    class: ['message-solid', {
      'active': _vm.visible
    }]
  }), _vm._v(" "), (_vm.isHaveUnread) ? _c('i', {
    staticClass: "red-circle"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "popover-content"
  }, [_c('p', {
    staticClass: "msg-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n                        消息通知\n                        "), _c('span', {
    staticClass: "num"
  }, [_vm._v("(" + _vm._s(_vm.msgLength) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "view-more",
    on: {
      "click": _vm.onViewMore
    }
  }, [_vm._v("查看更多")])]), _vm._v(" "), _c('el-tabs', {
    staticClass: "msg-content",
    on: {
      "tab-click": _vm.handleTabClick
    },
    model: {
      value: (_vm.activeMsg),
      callback: function($$v) {
        _vm.activeMsg = $$v
      },
      expression: "activeMsg"
    }
  }, _vm._l((_vm.msgTabList), function(tabItem) {
    return _c('el-tab-pane', {
      key: tabItem.name,
      staticClass: "tab-item",
      attrs: {
        "name": tabItem.name
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('el-badge', {
      attrs: {
        "hidden": !_vm.tabsTotal[tabItem.name],
        "value": _vm.tabsTotal[tabItem.name],
        "max": 99
      }
    }, [_vm._v("\n                        " + _vm._s(tabItem.label) + "\n                    ")])], 1)])
  }), 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading ? false : _vm.tabLoading),
      expression: "loading ? false : tabLoading"
    }],
    staticClass: "val-list",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [(_vm.componentData.length) ? _vm._l((_vm.componentData), function(infoItem, infoIndex) {
    return _c('li', {
      key: infoIndex,
      staticClass: "val-item"
    }, [_c('span', {
      staticClass: "val-circle"
    }), _vm._v(" "), _c('p', {
      staticClass: "val-content",
      domProps: {
        "innerHTML": _vm._s(_vm.filterXSS(infoItem.notify))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "val-time"
    }, [_vm._v(_vm._s(infoItem.updated))])])
  }) : _c('li', {
    staticClass: "data-null"
  }, [_c('img', {
    attrs: {
      "src": require("../images/personal_center/data-null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有数据")])])], 2)], 1)]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover",
      "width": "227",
      "popper-class": 'user-info-pop'
    }
  }, [_c('div', {
    staticClass: "user-info",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userInfo.nick_name))]), _vm._v(" "), (_vm.userInfo.is_official) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "蓝鲸智云官方",
      "placement": "right"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-lanjingguanfang"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.userInfo.is_vip) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "核心用户",
      "placement": "right"
    }
  }, [_c('span', {
    staticClass: "icon-vipuser"
  })]) : _vm._e()], 1), _vm._v(" "), _c('p', {
    staticClass: "whale",
    on: {
      "click": function($event) {
        return _vm.skip('/s-mart/personal_center/')
      }
    }
  }, [(!_vm.userInfo.avatar || _vm.userInfo.avatar.substr(0, 1) === '?') ? _c('img', {
    attrs: {
      "src": require("../images/community/coins.png")
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("鲸币")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.userInfo.bkb)))])]), _vm._v(" "), _c('p', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.skip('/s-mart/personal_center/')
      }
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('p', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.skip('/s-mart/personal_center/store')
      }
    }
  }, [_vm._v("鲸币商城")]), _vm._v(" "), _c('p', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.skip('/s-mart/vip')
      }
    }
  }, [_vm._v(_vm._s(_vm.userInfo.is_vip ? '查看我的核心权益' : '申请成为核心用户'))]), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    attrs: {
      "href": "javascript:smart.logout(logout_callback);"
    }
  }, [_vm._v("退出登录")])]), _vm._v(" "), _c('img', {
    staticClass: "triangle",
    attrs: {
      "src": require("../images/community/angle-down.png"),
      "alt": ""
    }
  })], _vm._v(" "), _c('secondary', {
    attrs: {
      "show": _vm.secondaryState,
      "hasEmail": _vm.emailState,
      "hasPhone": _vm.phoneState
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5bc28bee!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/header.vue
// module id = HBUr
// module chunks = 15